import React, { useState, useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";
import { useLocation } from "@reach/router";
import "../components/font-awsome";
import { FaTimes } from 'react-icons/fa';

const WrapperFloatQr = styled.div`
  width: 150px;
  height: 200px;
  position: fixed;
  margin-right: 20px;
  right: 0;
  bottom: 70px;
  z-index: 999;

  @media screen and (max-width: 1024px) {
    width: 130px;
    height: 180px;
  }

  @media screen and (max-width: 768px) {
    width: 100px;
    height: 150px;
  }

  .iconTimes {
    position: absolute;
    right: 0;
    color: #E40203;
    cursor: pointer;
  }
`;

const FloatQrComponent = ({ toggleIsFloatQr }) => {
  const data = useStaticQuery(graphql`
    query FloatQrInfo {
      datoCmsFloatQrcode {
        live22Qrcode {
          url
        }
        jokerQrcode {
          url
        }
        pgslotQrcode {
          url
        }
        slotxoQrcode {
          url
        }
        ambslotQrcode {
          url
        }
      }
    }
  `);
  const { pathname } = useLocation();
  const currentPath = pathname;
  const [currentPage, setCurrentPage] = useState("live22");
  const imagePath = {
    live22: data.datoCmsFloatQrcode.live22Qrcode.url,
    joker: data.datoCmsFloatQrcode.jokerQrcode.url,
    pgslot: data.datoCmsFloatQrcode.pgslotQrcode.url,
    slotxo: data.datoCmsFloatQrcode.slotxoQrcode.url,
    ambslot: data.datoCmsFloatQrcode.ambslotQrcode.url,
  }

  useMemo(() => {
    if (
      [
        "/",
        "/download",
        "/promotion",
        "/credit",
        "/contact",
        "/login",
        "/register",
        "/download/",
        "/promotion/",
        "/credit/",
        "/contact/",
        "/login/",
        "/register/",
      ].includes(currentPath)
    )
      setCurrentPage("live22");
    else setCurrentPage(currentPath.split("/")[1]);
  }, [currentPath]);

  return (
    <WrapperFloatQr>
      <FaTimes className="iconTimes" onClick={() => toggleIsFloatQr()}/>
      <img src={imagePath[currentPage]} alt="" />
    </WrapperFloatQr>
  );
};

export default FloatQrComponent;
